import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgAssist = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      d="M3.689 6.103q0 .157.109.273a.46.46 0 0 0 .275.13q1.03.114 1.726.272.704.15 1.16.424.457.267.732.726.276.453.443 1.164.174.713.312 1.761.029.159.137.259a.39.39 0 0 0 .522 0 .44.44 0 0 0 .145-.259q.138-1.05.305-1.76.167-.712.442-1.165.283-.46.74-.726.457-.273 1.153-.424a16 16 0 0 1 1.726-.273.44.44 0 0 0 .275-.13.38.38 0 0 0 .109-.272.36.36 0 0 0-.109-.266.42.42 0 0 0-.275-.137 18 18 0 0 1-1.726-.266q-.697-.157-1.153-.424a2.1 2.1 0 0 1-.732-.726q-.276-.46-.45-1.171a18 18 0 0 1-.305-1.76.42.42 0 0 0-.137-.252A.38.38 0 0 0 8.844 1a.37.37 0 0 0-.26.1.42.42 0 0 0-.138.252 18 18 0 0 1-.32 1.747q-.165.704-.442 1.157a2.14 2.14 0 0 1-.732.718q-.45.266-1.153.432-.697.158-1.726.294a.45.45 0 0 0-.283.137.37.37 0 0 0-.101.266M3 12.363q0 .107.073.194a.3.3 0 0 0 .188.107q.696.13 1.08.23.392.095.58.273.19.18.269.54.087.359.167 1.005a.37.37 0 0 0 .101.202.28.28 0 0 0 .203.086q.123 0 .203-.08a.35.35 0 0 0 .109-.2q.087-.675.174-1.057.095-.373.29-.553.196-.187.573-.266a14 14 0 0 1 1.044-.18.34.34 0 0 0 .196-.1.294.294 0 0 0 .007-.395.32.32 0 0 0-.196-.108q-.674-.13-1.058-.223-.378-.1-.573-.28-.189-.18-.283-.54-.087-.36-.174-1.02a.31.31 0 0 0-.109-.194.3.3 0 0 0-.203-.08.3.3 0 0 0-.203.08.37.37 0 0 0-.101.208 10 10 0 0 1-.167 1.014q-.08.36-.268.546-.182.186-.566.287-.385.094-1.066.202-.29.05-.29.301"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgAssist);
export default ForwardRef;
